import { Action } from '@ngrx/store';

import { HideLoader } from '../../../../shared/decorators/hide-loader';
import { ShowLoader } from '../../../../shared/decorators/show-loader';
import { CountryCard } from '../country-card.model';

export enum CountryCardActionTypes {
    LoadCountryCards = '[Country card] Load',
    LoadCountryCardsSuccess = '[Country card] Load success',
    LoadCountryCardsFail = '[Country card] Load fail',
    UpdateCountryCard = '[Countries card] Update',
    UpdateCountryCardSuccess = '[Country card] Update success',
    UpdateCountryCardFail = '[Country card] Update fail',
    CreateCountryCard = '[Countries card] Create',
    CreateCountryCardSuccess = '[Country card] Create success',
    CreateCountryCardFail = '[Country card] Create fail',
    DeleteCountryCard = '[Countries card] Delete',
    DeleteCountryCardSuccess = '[Country card] Delete success',
    DeleteCountryCardFail = '[Country card] Delete fail',
    ClearCountryCards = '[Country card] Clear'
}
@ShowLoader()
export class LoadCountryCards implements Action {
    readonly type = CountryCardActionTypes.LoadCountryCards;
    constructor() { }
}

@HideLoader(CountryCardActionTypes.LoadCountryCards)
export class LoadCountryCardsSuccess implements Action {
    readonly type = CountryCardActionTypes.LoadCountryCardsSuccess;
    constructor(public payload: CountryCard[]) { }
}
@HideLoader(CountryCardActionTypes.LoadCountryCards)
export class LoadCountryCardsFail implements Action {
    readonly type = CountryCardActionTypes.LoadCountryCardsFail;
    constructor(public payload: string) { }
}

@ShowLoader()
export class UpdateCountryCard implements Action {
    readonly type = CountryCardActionTypes.UpdateCountryCard;
    constructor(public countryCard: CountryCard) { }
}
@HideLoader(CountryCardActionTypes.UpdateCountryCard)
export class UpdateCountryCardSuccess implements Action {
    readonly type = CountryCardActionTypes.UpdateCountryCardSuccess;
    constructor(public countryCard: CountryCard) { }
}
@HideLoader(CountryCardActionTypes.UpdateCountryCard)
export class UpdateCountryCardFail implements Action {
    readonly type = CountryCardActionTypes.UpdateCountryCardFail;
    constructor(public payload: string) { }
}

@ShowLoader()
export class CreateCountryCard implements Action {
    readonly type = CountryCardActionTypes.CreateCountryCard;
    constructor(public countryCard: CountryCard) { }
}
@HideLoader(CountryCardActionTypes.CreateCountryCard)
export class CreateCountryCardSuccess implements Action {
    readonly type = CountryCardActionTypes.CreateCountryCardSuccess;
    constructor(public countryCard: CountryCard) { }
}
@HideLoader(CountryCardActionTypes.CreateCountryCard)
export class CreateCountryCardFail implements Action {
    readonly type = CountryCardActionTypes.CreateCountryCardFail;
    constructor(public payload: string) { }
}

@ShowLoader()
export class DeleteCountryCard implements Action {
    readonly type = CountryCardActionTypes.DeleteCountryCard;
    constructor(public countryCard: CountryCard) { }
}
@HideLoader(CountryCardActionTypes.DeleteCountryCard)
export class DeleteCountryCardSuccess implements Action {
    readonly type = CountryCardActionTypes.DeleteCountryCardSuccess;
    constructor(public countryCard: CountryCard) { }
}
@HideLoader(CountryCardActionTypes.DeleteCountryCard)
export class DeleteCountryCardFail implements Action {
    readonly type = CountryCardActionTypes.DeleteCountryCardFail;
    constructor(public payload: string) { }
}

export class ClearCountryCards implements Action {
    readonly type = CountryCardActionTypes.ClearCountryCards;
}

export type CountryCardActions = LoadCountryCards | LoadCountryCardsSuccess | LoadCountryCardsFail
    | UpdateCountryCard | UpdateCountryCardSuccess | UpdateCountryCardFail
    | CreateCountryCard | CreateCountryCardSuccess | CreateCountryCardFail
    | DeleteCountryCard | DeleteCountryCardSuccess | DeleteCountryCardFail
    | ClearCountryCards
    ;


